import React, { createContext, useState } from "react";
export const NumberMonitorContext = createContext();

const NumberMonitorProvider = ({ children }) => {
	const [monitorFilter, setMonitorFilter] = useState({
		sector: "",
		server: { label: "", value: "" },
		client: { label: "", value: "" },
		number: "",
	});
	return (
		<NumberMonitorContext.Provider value={{ monitorFilter, setMonitorFilter }}>
			{children}
		</NumberMonitorContext.Provider>
	);
};

export { NumberMonitorProvider };
